// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"af777004","158":"e4b24553","172":"d750eade","191":"af6c5fc0","425":"58f516ee","495":"65795722","639":"70d01736","701":"e9dafca4","787":"49f48831","871":"a8f55b3b"}[chunkId] + ".chunk.js";
};